import type React from "react"

import {cn} from "@/lib/cn"

/** Loading placeholder with the DIZED shimmer. */
export const Skeleton = ({className, ...props}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("animate-shimmer rounded-mini bg-foreground/10", className)} {...props} />
)

/** Circular spinner for inline pending states. */
export const Spinner = ({className, ...props}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    role="status"
    aria-label="Loading"
    className={cn(
      "size-5 animate-spin rounded-full border-2 border-foreground/20 border-t-link",
      className,
    )}
    {...props}
  />
)
